// extracted by mini-css-extract-plugin
module.exports = {"filtersContent":"filtersContent__filtersContent___2oR6X","active":"filtersContent__active___3fq7D"};